module.exports = __webpack_public_path__ + "static/media/dudumfinancial--logo.589a2cde.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/dudumfinancial/dudumfinancial--logo.svg
// module id = 183
// module chunks = 0